import styled from "styled-components";
import colors from "../../theme/colors";

export const Wrapper = styled.section`
  height: 100%;
`;

export const ItemsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`;

export const TopWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px 0 12px;
`;

export const ProjectNameWrapper = styled.div`
  display: flex;
  width: fit-content;
  background-color: ${colors.gray};
  justify-content: start;
  align-items: center;
  border-radius: 4px;
  padding-left: 7px;
  font-weight: 600;
  margin: 10px;
  margin-left: 30px;
`;

export const TextInput = styled.input`
  text-decoration: none;
  border-style: none;
  padding: 10px;
  outline: none;
  width: 100%;
  background-color: transparent;
  font-size: 20px;
  letter-spacing: 2px;
`;

export const Button = styled.button`
  outline: none;
  background-color: #2ed573;
  padding: 6px;
  border: none;
  border-radius: 4px;
  box-shadow: rgba(65, 60, 77, 0.1) 2px 0rem 1rem, rgba(65, 60, 77, 0.05) 22px 1px 2rem;
  font-size: 20px;
  cursor: ${props => (props.active ? " pointer" : "not-allowed")};

  opacity: ${props => (props.active ? 1 : 0.5)};

  svg {
    margin-right: 5px;
  }
`;

export const BlockContainer = styled.section`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;

export const Block = styled.div`
  display: grid;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
`;

export const SliderBlock = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 260px;
  justify-content: center;
  align-items: center;
  padding: 0 30px 0 10px;
`;

export const SliderWrapper = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 0.5fr 1fr 0.1fr;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0px 10px;
`;

export const SliderShape = styled.div`
  width: 100%;
  box-shadow: rgba(65, 60, 77, 0.1) 2px 0rem 1rem, rgba(65, 60, 77, 0.05) 22px 1px 2rem;
  margin: 10px;
  border-radius: 6px;
`;

export const Text = styled.p`
  padding: 5px;
  margin: 0;
  text-transform: capitalize;
`;

export const HeaderOptions = styled.h2`
  text-align: center;
`;

export const H3 = styled.h3`
  text-align: center;
`;

export const InfoText = styled.p`
  padding: 5px;
  margin-bottom: 10px;
  color: #999;
`;

export const ThreeBox = styled.section`
  margin-top: 10px;
  height: calc(50vh - 210px);
  width: 100%;
`;

export const FigureInfomationWrapper = styled.div`
  text-align: center;
`;

